export function isEmptyValue (value) {
  return value == null || String(value).trim() === ''
}

export function capitalizeFirstLetter (value) {
  if (typeof value === 'string' && value !== '') {
    return value[0].toUpperCase() + value.slice(1)
  }

  return value
}
